export default {
  components: {
    stationSelector: {
      title: 'station selector'
    },
    datePicker: {
      title: 'date picker'
    }
  },
  dashboard: {
    title: 'dashboard'
  }
};
